import React, { Component } from 'react';

//Images
import Organism from '../../../images/icon-organism.png';
//import Placeholder from '../../../images/placeholder.png';

//Components
import Image from '../atoms/Image';
//import FormSignUp from '../organisms/FormSignUp';
//import FormLogin from '../organisms/FormLogin';
//import FormCreateBot from '../organisms/FormCreateBot/FormCreateBot';
//import FormCreateSubject from '../organisms/FormCreateSubject/FormCreateSubjectContainer';
//import FormPasswordReset from '../organisms/FormPasswordReset';
//import SignUpTestimonial from '../organisms/SignUpTestimonial';
//import NavigationLogin from '../organisms/NavigationLogin';
//import DashboardNavigation from '../organisms/DashboardNavigation/DashboardNavigationContainer';
//import FacebookConnect from '../organisms/FacebookConnect/FacebookConnect';
//import FacebookPages from '../organisms/FacebookPages';
//import SubjectListing from '../organisms/SubjectListing';
//import QuestionBuilder from '../organisms/QuestionBuilder';
//import AnswerBuilder from '../organisms/AnswerBuilder';
//import ConversationBuilder from '../organisms/ConversationBuilder';
//import PopupMessage from '../organisms/PopupMessage';
//import FormDeleteBot from '../organisms/FormDeleteBot';

import EmailVerify from '../organisms/EmailVerify';
import FormProfile from '../organisms/FormProfile';
import FormCompany from '../organisms/FormCompany';
import ChangePassword from '../organisms/ChangePassword';
import DeactivateAccount from '../organisms/DeactivateAccount';
import FormChangePassword from '../organisms/FormChangePassword';
import FormBillingInformation from '../organisms/FormBillingInformation';
import CreditCard from '../organisms/CreditCard';
import AddCreditCard from '../organisms/AddCreditCard';
import FormCreditCard from '../organisms/FormCreditCard';
import YourPlan from '../organisms/YourPlan';
import InvoiceTable from '../organisms/InvoiceTable';
import DropdownMenu from '../organisms/DropdownMenu';









class Organisms extends Component {
	render() {
		return (
			<div className="styleguide">
				<div className="container">
					<div className="styleguide__section">
						<div className="styleguide__header">
							<Image classType="atomicDesign_headerImage" src={Organism} alt="Atoms" />
							<h1 className="textHeadingOne color-black">Organisms</h1>
						</div>

							<EmailVerify heading="Email verification" paragraphText="To complete the registration process look for an email in your inbox that provides further instructions. If you cannot find the email, please check your spam email."/>
						<FormProfile/>
						<FormCompany/>
						<ChangePassword/>
						<DeactivateAccount/>
						<FormChangePassword/>
						<FormBillingInformation/>
					
						<CreditCard company="Nordea Bank Ab" number="**** **** **** 2562" date="2018/07/10"/>
						<AddCreditCard/>
						<FormCreditCard/>
						<YourPlan currentPlan="Basic | $15/m" features="5 chatbot" renewal="Your plan will be renewed automatically on 2018-01-29 and you will be charged $15."/>

						<InvoiceTable invoice="Inovice #2" date="2017/02/27" price="$15" href="#"/>

						<DropdownMenu iconType="fa-cog" listItem="Testing"/>
					

						{/*
						<PopupMessage PopupMessageIcon="fa-check color-success"/>
						<PopupMessage PopupMessageIcon="fa-close color-error"/>

						<FormDeleteBot textData="test" />

						<FormSignUp
							//Heading & Text
							textHeadingOne="Get started absolutely free."
							textParagraph="Launch a chatbot in less than 5 minutes"

							//Global
							formWrapperClassType=""
							formGroupClassType=""
							textfieldClassType=""
							textFieldForm=""
							textFieldOnChange=""
							errorMessageClassType=""

							//Username
							username="Username"
							errorMessageUsername="Invalid username"

							//Email
							email="Email address"
							errorMessageEmail="Invalid email"

							//Password
							password="Password"
							errorMessagePassword="Invalid password"

							//Verify password
							verifyPassword="Verify password"
							errorMessageVerifyPassword="Invalid password"

							//Button
							formButtonText="Create account"
							formButtonClassType="btn--medium"
						/>

						<hr className="margin-y-50"></hr>


						<FormLogin

							//Heading & Text
							textHeadingOne="Login"
							textParagraph="Enter your details below"

							//Global
							formWrapperClassType=""
							formGroupClassType=""
							textfieldClassType=""
							textFieldForm=""
							textFieldOnChange=""
							errorMessageClassType=""

							//Email
							email="Email address"
							errorMessageEmail="Invalid email"

							//Password
							password="Password"
							errorMessagePassword="Invalid password"

							//Forgot poassword
							forgotPassword="Forgot password?"
							href="#clicked"

							//Button
							formButtonText="Create account"
							formButtonClassType="btn--medium"
						/>

						<FormCreateBot

							//Heading & Text
							textHeadingOne="New bot"
							textParagraph="Enter the details below"

							//Global
							formWrapperClassType=""
							formGroupClassType=""
							textfieldClassType=""
							textFieldForm=""
							textFieldOnChange=""
							errorMessageClassType=""

							//Bot name
							botName="Bot name"
							errorMessageBotName="Invalid name, must contain atleast three characters"
							botNamePlaceholder="Tredan"

							//Description
							description="Description"
							errorMessagePassword="Invalid description"
							descriptionPlaceholder="This bot is used for..."

							//Button
							formButtonText="Create bot"
							formButtonClassType="btn--medium"
						/>



						<hr className="margin-y-50"></hr>

						<FormPasswordReset

							//Heading & Text
							textHeadingOne="Reset your password"
							textParagraph="Provide your email and we'll send you a password reset link"

							//Global
							formWrapperClassType=""
							formGroupClassType=""
							textfieldClassType=""
							textFieldForm=""
							textFieldOnChange=""
							errorMessageClassType=""

							//Email
							email="Email address"
							errorMessageEmail="Invalid email"

							//Button
							formButtonText="Create account"
							formButtonClassType="btn--medium"

							//Back to login
							backToLogin="Send me back to the login screen"
							href="#clicked"
						/>

						<SignUpTestimonial textBlockquote="One of the best tools I have ever used. It is easy to use and very productive, every restaurant should have a chatbot in Facebook!" textHeadingThree="Ezequiel Treviño" textParagraph="Owner of El Rey Tiburón" />

						<NavigationLogin
							textParagraph="Already have an account?"
							textButton="Login"
							href="#clicked"
						/>

						<DashboardNavigation />

						<FacebookPages
							panelMenuText="Menu"
							panelMenuHref="#clicked"
							pageTitle="Facebook"
							panelHeading="Link to facebook"
							panelText="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam."
							FacebookPage="Lorem ipsum"
						/>

						<FacebookConnect
							panelMenuText="Menu"
							panelMenuHref="#clicked"
							panelHeading="Link to facebook"
							panelText="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam."
							buttonText="Connect to your facebook account"
						/>



						<SubjectListing
							panelMenuText="Menu"
							panelMenuHref="#clicked"
							panelHeading="Subjects"
							panelText="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam."
							subject="Welcome"
							subjectHref="#clicked"
							addSubjecet="New subject"
							deleteSubject="Delete selected"
						/>
					
						<FormCreateSubject />
						<QuestionBuilder id="test" placeholder="test" name="test" form="test" onChange="test" />
						<AnswerBuilder placeholder="test" answerNumber="1" />
						<ConversationBuilder idQuestion="test" placeholderQuestion="test" nameQuestion="test" formQuestion="test" onChangeQuestion="test" placeholderAnswer="test" answerNumber="1"/>
											*/}
											
											
											

											
					</div>
				</div>
			</div>
		)
	}
}

export default Organisms;


// WEBPACK FOOTER //
// ./src/redux/components/templates/Organisms.jsx